import { Banner } from "../components/banner/Banner"
import { PageContainer } from "../components/pageContainer/PageContainer"
import AboutBan from '../assets/img/about-ban.jpg'
import { ManagementTeam } from "../layout/managementTeam/ManagementTeam"

export const About = () => {
    return (
        <PageContainer>
            <Banner img={AboutBan} />
            <ManagementTeam />
        </PageContainer>
    )
}